module.exports = __webpack_public_path__ + "media/test_music.36a4be16.mp3";